import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

//Theme used for PrismJS code syntax highlighting.
import "prismjs/themes/prism.css";

import Header from '../components/Header'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="alexk.io"
      meta={[
        { name: 'description', content: 'RandomStringUtils.randomAlphanumeric(10);' },
        { name: 'keywords', content: 'blog,tech,programming,travel,outdoors' },
      ]}
      links={[{
        rel: 'icon',
        type: 'image/x-icon',
        href: '/favicon.ico',
      }]}
    />
    <Header />
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '0px 1.0875rem 1.45rem',
        paddingTop: 0,
      }}
    >
      {children()}
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js